<main>
  <div class="container">
    <div class="dropdown">
      <label class="date-picker-range-label">Select Channels </label>
      <icn-dropdown
        *ngIf="activeChannelsList.length > 0"
        [(selectedValues)]="selectedChannelsList"
        [listDown]="true"
        [allowMultiple]="true"
        (selectedValuesChange)="saveFiltersState()"
      >
        <icn-dropdown-item
          *ngFor="let activeChannel of activeChannelsList"
          [title]="activeChannel.item_text"
          [value]="activeChannel.item_id"
          [showSettings]="false"
        >
        </icn-dropdown-item>
      </icn-dropdown>
    </div>
    <div class="calendar">
      <label class="date-picker-range-label">Until: </label>
      <div
        id="calPicker"
        class="calendar-container"
        (click)="showDatepicker()"
        outsideClick
        (outsideClick)="onClickedOutside()"
        (keyup.escape)="onClickedOutside()"
      >
        {{ dateTo.format("YYYY/MM/DD HH:mm") }} UTC

        <icn-calendar-datepicker
          [dateTime]="dateTo"
          (apply)="onDatepickerApply($event)"
          (cancel)="hideDatepicker()"
        >
        </icn-calendar-datepicker>

        <div class="calendar-icon">
          <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="19"
            viewBox="0 0 23 19"
          >
            <g>
              <rect x="8" y="8" width="1" height="1" />
              <rect x="4" y="12" width="1" height="1" />
              <rect x="4" y="8" width="1" height="1" />
              <polygon points="5 3 5 2 5 1 4 1 4 2 4 3 4 4 5 4 5 3" />
              <polygon points="15 3 15 2 15 1 14 1 14 2 14 3 14 4 15 4 15 3" />
              <path d="M3,14H6V11H3Zm1-2H5v1H4Z" />
              <path d="M10,7H7v3h3ZM9,9H8V8H9Z" />
              <path d="M3,10H6V7H3ZM4,8H5V9H4Z" />
              <path
                d="M16,9h1v5H16l-2-3,.8-.6L16,12Zm7,3.5A6.5,6.5,0,0,1,11.8,17H1.7A1.7,1.7,0,0,1,0,15.3V3.7A1.7,1.7,0,0,1,1.7,2H3V0H6V2h7V0h3V2h1.3A1.7,1.7,0,0,1,19,3.7V6.5L20,7A6.5,6.5,0,0,1,23,12.5ZM14,4h1V1H14V4ZM4,4H5V1H4V4Zm7,12-.5-1a6.5,6.5,0,0,1,6-9l1.5.2V3.7a.7.7,0,0,0-.7-.7H16V5H13V3H6V5H3V3H1.7a.7.7,0,0,0-.7.7V15.3a.7.7,0,0,0,.7.7Zm11-3.5a5.5,5.5,0,0,0-2-4.2l-1-.7-1-.4L16.5,7a5.5,5.5,0,0,0-4.9,8l.7,1,1.1,1A5.5,5.5,0,0,0,22,12.5Z"
              />
            </g>
          </svg>
        </div>
      </div>
    </div>
    <div class="dropdown">
      <label class="date-picker-range-label">Issue Types </label>
      <icn-dropdown
        [(selectedValues)]="selectedIssueTypes"
        [listDown]="true"
        [allowMultiple]="true"
        (selectedValuesChange)="saveFiltersState()"
      >
        <icn-dropdown-item
          *ngFor="let issueType of issueTypesList"
          [title]="issueType.item_text"
          [value]="issueType.item_id"
          [showSettings]="false"
        >
        </icn-dropdown-item>
      </icn-dropdown>
    </div>
    <div class="buttons">
      <button
        class="button"
        (click)="getSchedulerAlerts()"
        [disabled]="isLoading"
      >
        Send
      </button>
      <button
        *ngIf="lastResult && lastResult.length > 0"
        class="button"
        (click)="saveAsCSV()"
        [disabled]="isLoading"
      >
        Save as CSV
      </button>
    </div>
  </div>

  <div class="report-results">
    <ag-grid-angular
      class="ag-theme-balham ag-theme-evrideo"
      style="margin: 0 auto"
      (gridReady)="onGridReady($event)"
      [gridOptions]="gridOptions"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [overlayLoadingTemplate]="overlayLoadingTemplate"
    ></ag-grid-angular>

    <ag-grid-evrideo-footer
      [showPageSizeSelector]="false"
      [gridApi]="gridApi"
      (goToPageClicked)="goToPage($event)"
      (pageSizeChanged)="setPageSize($event)"
    >
    </ag-grid-evrideo-footer>
  </div>
</main>
